import { render, staticRenderFns } from "./LayoutFooter.vue?vue&type=template&id=eba56dfe&scoped=true&"
import script from "./LayoutFooter.vue?vue&type=script&lang=js&"
export * from "./LayoutFooter.vue?vue&type=script&lang=js&"
import style0 from "./LayoutFooter.vue?vue&type=style&index=0&id=eba56dfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eba56dfe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eba56dfe')) {
      api.createRecord('eba56dfe', component.options)
    } else {
      api.reload('eba56dfe', component.options)
    }
    module.hot.accept("./LayoutFooter.vue?vue&type=template&id=eba56dfe&scoped=true&", function () {
      api.rerender('eba56dfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/LayoutFooter.vue"
export default component.exports